import { TreatmentType } from 'app/core/enums';

export const TreatmentTypeConfig = [TreatmentType.Veneers, TreatmentType.Moment, TreatmentType.NightGuard];
